import { Form2 } from "../../misc/Form2";
import { Column } from "../../misc/Column";
import { CheckboxGroupInput, ReferenceArrayInput, required, SelectArrayInput, TextInput } from "react-admin";
import { VehicleFormToolbar } from "../../misc/VehicleFormToolbar";
import { type SxProps } from "@mui/material";
import { useAutovioContext } from "../../hooks/useAutovioContext";
import { EntitledInstructorsInput } from "../../inputs/EntitledInstructorsInput";
import { BUS_DRIVING_LICENSE_CLASSES } from "../../model/DrivingLicenseClass";

export function BusForm({ mode, sx }: { mode: "create" | "edit"; sx?: SxProps }) {
  const [{ drivingSchoolId }] = useAutovioContext();

  if (!drivingSchoolId) {
    return null;
  }

  return (
    <Form2
      defaultValues={{
        type: "bus",
        drivingSchoolId,
        name: "",
        notes: "",
        plateNumber: "",
        drivingLicenseClasses: [],
        adasIds: [],
        entitledInstructorIds: [],
      }}
      warnWhenUnsavedChanges
    >
      <Column sx={sx}>
        <TextInput label="Name" source="name" fullWidth autoFocus={mode === "create"} validate={required()} />
        <TextInput label="Notizen" source="notes" fullWidth />
        <TextInput label="Kennzeichen" source="plateNumber" validate={required()} sx={{ width: "150px" }} />
        <CheckboxGroupInput
          label="geeignet für Führerscheinklasse(n)"
          source="drivingLicenseClasses"
          choices={[...BUS_DRIVING_LICENSE_CLASSES].map((val) => ({ id: val, name: val }))}
          validate={required("Bitte wähle mindestens eine Führerscheinklasse aus")}
        />
        <ReferenceArrayInput source="adasIds" reference="adas">
          <SelectArrayInput label="Assistenzsysteme" defaultValue={[]} sx={{ minWidth: { xs: 0, sm: "337px" } }} />
        </ReferenceArrayInput>
        <EntitledInstructorsInput source="entitledInstructorIds" />
        <VehicleFormToolbar />
      </Column>
    </Form2>
  );
}
